import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";

export default function ConfirmModal({ open, onClose, onConfirm, title, message, theme }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="confirm-modal"
      PaperProps={{
        className: "confirm-modal-paper",
      }}
    >
      <DialogTitle>
        <Typography className="confirm-title">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography className="confirm-message">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} className="confirm-cancel-btn">
          Cancelar
        </Button>
        <Button 
          onClick={onConfirm} 
          className="confirm-action-btn"
          style={{ backgroundColor: theme.primary }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
